import { render, staticRenderFns } from "./GestionOrganismeThNew.vue?vue&type=template&id=15ca23a0&scoped=true&"
import script from "./GestionOrganismeThNew.vue?vue&type=script&lang=js&"
export * from "./GestionOrganismeThNew.vue?vue&type=script&lang=js&"
import style0 from "./GestionOrganismeThNew.vue?vue&type=style&index=0&id=15ca23a0&lang=scss&scoped=true&"
import style1 from "./GestionOrganismeThNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca23a0",
  null
  
)

export default component.exports